import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router";
import "../../assets/css/style.css";
import "../../assets/css/login.css";
import { API } from "../../services/api";
import { getUserDetails } from "../../services/apiProfile";
import "../../assets/css/style_new.css";
import profileimg from "../../assets/img/profile/profile-img.svg"
import eye from "../../assets/img/profile/eye.svg"
import edit from "../../assets/img/profile/edit.svg"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import ProfileBio from "./ProfileBio";
import ProfileCommunity from "./ProfileCommunity";
import Spinner from "../../commonComponents/Spinner";
import UpcomingEvents from "./UpcomingEvents";
import MyDiscussions from "./MyDiscussions";
import SavedPost from "./SavedPost";
import Favorites from "./Favourites";
import About from "./About";
const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const data = location.state || {};
  const [userArr, setUserArr] = useState([]);
  const [postArr, setPostArr] = useState([]);
  const [isBio, setIsBio] = useState(false);
  const [loader, setLoader] = useState(false);
  const [isCommunity, setIsCommunity] = useState(false);
  const [activeTab, setActiveTab] = useState( localStorage.getItem('profileTab') ? localStorage.getItem('profileTab') : "Discussion" );
  const[about,setAbout] =useState({});
  const handleBioClose = () => setIsBio(false);
  const handleCommunityClose = () => setIsCommunity(false);
  const maxChars = 60;
  const user = JSON.parse(localStorage.getItem('userData'));
  
  
  useEffect(() => {

    if (user) {
      fetchUserDetails(user._id, 10, 0);
    }
  }, [])
  const fetchUserDetails = async (id, limit, offset) => {
    setLoader(true)
    const formData = {
      userid: user._id,
      offset: offset ? offset : 0,
      limit: limit ? limit : 10
    }
    let listUserData = await getUserDetails(formData);
    setUserArr(listUserData);
    setPostArr(listUserData.posts);
    setAbout(listUserData.user);
  
    setLoader(false)

   
  };
  const handleTabSelect = (eventKey) => {
    setActiveTab(eventKey);
     localStorage.setItem("profileTab",(eventKey));
    switch (eventKey) {
      case 'Discussion':
        if (user) {
          fetchUserDetails(user._id, 10, 0);
        }
        break;
      case 'UpcomingEvents':
        break;
      case 'Saved':
        if (user) {
          fetchUserDetails(user._id, 10, 0);
        }
        break;
      case 'Favorites':
        fetchUserDetails(user._id, 50, 0);
        break;
      default:
        break;
    }
  };
  
  
  return (

    <div >
      {loader && <Spinner />}
      <div className="main">
        <div className="contents">
          <div className="profile_user">
            <div className="coverimage">
              <img src={
                userArr?.user?.coverImage?.url
                  ? API.uploadFilePath + userArr.user.coverImage?.url
                  : profileimg
              } alt="test" className="cover_profile" />
              <div className="overlay"></div>
            </div>
            <div className="profile_main d-flex align-items-start">
              <div className="profile_avatar">
                <img src={
                  userArr?.user?.profileImage?.url
                    ? API.uploadFilePath + userArr.user.profileImage?.url
                    : profileimg
                } alt="test" className="cover_profile" />
              </div>
              <div className="profile_details flex-fill">
                <div className="avatarname_full d-flex-c">
                  <h3>{userArr?.user?.firstName }</h3>
                  <Link className="profile_edit" to='/edit-organization'>
                    <img src={edit} alt="test" className="p-icon" />
                    Edit Profile</Link>
                </div>
                <div className="avatar_other-details d-flex-c align-items-stretch">

                  <div className="details_itms w-50">
                    <h4>Description</h4>
                    <p>{userArr.user?.bio?.slice(0, maxChars)}
                      {userArr.user?.bio?.length > maxChars && <Link className="profile_edit" onClick={() => setIsBio(true)} >View more</Link>}
                    </p>
                  </div>

                

                  <div className="details_itms communities">
                    <h4>Communities</h4>
                    <ul className="profile_community d-flex flex-wrap" >
                      {userArr?.communities?.length > 4 ?
                        userArr.communities.slice(0, 3).map((community, index) => (
                          <li key={community._id}>
                            <img src={
                              community?.communityId?.profileImage?.url
                                ? API.uploadFilePath + community.communityId.profileImage.url
                                : profileimg
                            } alt="test" className="community_thumb" />
                            <span>{community?.communityId?.communityName} </span>
                          </li>)) :
                        userArr?.communities?.length === 1 ?
                          userArr?.communities?.map((community, index) => (
                            <li key={community._id} className="full-width">
                              <img src={
                                community?.communityId?.profileImage?.url
                                  ? API.uploadFilePath + community.communityId.profileImage.url
                                  : profileimg
                              } alt="test" className="community_thumb" />
                              <span>{community?.communityId?.communityName}</span>
                            </li>)) :
                          userArr?.communities?.map((community, index) => (
                            <li key={community._id}>
                              <img src={
                                community?.communityId?.profileImage?.url
                                  ? API.uploadFilePath + community.communityId.profileImage.url
                                  : profileimg
                              } alt="test" className="community_thumb" />
                              <span>{community?.communityId?.communityName}</span>
                            </li>))}

                      {userArr?.communities?.length > 4 &&
                        <li>
                          <Link href="#" className="viewall" onClick={() => setIsCommunity(true)}>
                            <img src={eye} alt="test" className="community_thumb" />
                            <span>View all </span>
                          </Link>
                        </li>}
                    </ul>
                  </div>

                </div>
              </div>
            </div>
          </div>
         
             <Tabs  activeKey={activeTab} id="fill-tab-example" className="mt-5 profile_tabs" fill onSelect={handleTabSelect}>

            <Tab eventKey="Discussion" className="profile-tab-contents mt-4" title="My Discussions / Posts">
              <MyDiscussions Feeds={postArr} User={userArr} fetchUserDetails={fetchUserDetails} />
            </Tab>
            <Tab eventKey="UpcomingEvents" className="profile-tab-contents mt-4" title="Events">
              <UpcomingEvents type="profile" />
            </Tab>


           { <Tab eventKey="Saved" className="profile-tab-contents mt-4" title="Saved">
              <SavedPost />
            </Tab>}


            <Tab eventKey="Favorites" className="profile-tab-contents mt-4" title="Favorites">
              <Favorites Favorite={userArr.favouriteMembers} user={user._id} getUser={fetchUserDetails} />
            </Tab>
          </Tabs>
         
           
        </div>
        <About about={about} />

      </div>
     {isBio ? <ProfileBio isBio={isBio} handleClose={handleBioClose} name={userArr?.user?.userType === "Organization" ? userArr?.user?.firstName + " " + userArr?.user?.lastName : userArr?.user?.firstName} content={userArr?.user?.bio} /> : null}
      {isCommunity ? <ProfileCommunity isCommunity={isCommunity} handleClose={handleCommunityClose} community={userArr?.communities} /> : null}
    </div>
  );

};
export default Profile;
